import { MapLocation } from '@/types/location';

export const digitalSuperMegaScreens: MapLocation[] = [
  {
    id: 10022,
    name: "Digital Super Mega Screen – Al Jubail",
    type: "Digital Super Mega",
    devices: 2,
    coordinates: [26.960194, 49.649250], // Converted from 26°57'36.7"N 49°38'57.3"E
    region: "Al Jubail",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital super mega screen with 2 faces\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 7m",
      referenceImage: "/images/32869305-222d-4e93-8d81-f4650d504806.png"
    }
  },
  {
    id: 10023,
    name: "Digital Super Mega Screen – Eastern Province",
    type: "Digital Super Mega",
    devices: 2,
    coordinates: [27.002541667, 49.643611111], // Converted from 27°00'11.5"N 49°38'38.6"E
    region: "Al Jubail",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital super mega screen with 2 faces\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 7m",
      referenceImage: "/images/6e130912-6132-446c-b2c5-0ccc50d08e6e.png"
    }
  },
  {
    id: 10024,
    name: "Digital Super Mega Screen – Al Jubail 2",
    type: "Digital Super Mega",
    devices: 2,
    coordinates: [27.00455556, 49.66075], // Converted from 27°00'16.4"N 49°39'38.7"E
    region: "Al Jubail",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital super mega screen with 2 faces\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 7m",
      referenceImage: "/images/b1ecd604-6d46-4d16-91ba-406c06b902de.png"
    }
  },
  {
    id: 10029,
    name: "Digital Super Mega Screen – Khamis Mushait",
    type: "Digital Super Mega",
    devices: 1,
    coordinates: [18.316499889, 42.756055556], // Converted from 18°18'59.4"N 42°44'63.8"E (corrected longitude)
    region: "Khamis Mushait",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital super mega screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 7m",
      referenceImage: "/images/e764eb77-cee2-4cee-9f6b-ea9047967ec2.png"
    }
  },
  {
    id: 10030,
    name: "Digital Super Mega Screen – Khamis Mushait 2",
    type: "Digital Super Mega",
    devices: 1,
    coordinates: [18.316388889, 42.729666667], // Converted from 18°18'57.0"N 42°43'46.8"E
    region: "Khamis Mushait",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital super mega screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 7m",
      referenceImage: "/images/bbecf51d-1add-4d28-85e4-f647b52c5606.png"
    }
  },
  {
    id: 10031,
    name: "Digital Super Mega Screen – Khamis Mushait 3",
    type: "Digital Super Mega",
    devices: 1,
    coordinates: [18.299722222, 42.728333333], // Converted from 18°17'59.0"N 42°43'42.0"E
    region: "Khamis Mushait",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital super mega screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 7m",
      referenceImage: "/images/aeb8e9c2-874d-420a-a909-6749523054b8.png"
    }
  },
  {
    id: 10032,
    name: "Digital Super Mega Screen – Khamis Mushait 4",
    type: "Digital Super Mega",
    devices: 1,
    coordinates: [18.254972222, 42.754861111], // Converted from 18°15'17.9"N 42°45'17.5"E
    region: "Khamis Mushait",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital super mega screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 7m",
      referenceImage: "/images/80410580-eed8-481d-8ea7-29b7e7fbee14.png"
    }
  },
  {
    id: 10033,
    name: "Digital Super Mega Screen – Khamis Mushait 5",
    type: "Digital Super Mega",
    devices: 1,
    coordinates: [18.271333333, 42.707305556], // Converted from 18°16'16.8"N 42°42'28.3"E
    region: "Khamis Mushait",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital super mega screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 7m",
      referenceImage: "/images/deaf1d8c-8cdd-442c-823e-a69abf6d6931.png"
    }
  },
  {
    id: 10034,
    name: "Digital Super Mega Screen – Sabia",
    type: "Digital Super Mega",
    devices: 2,
    coordinates: [17.148194, 42.6447222], // Converted from 17°08'56.5"N 42°38'41.0"E
    region: "Sabia",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital super mega screen with 2 faces\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 7m",
      referenceImage: "/images/2d9ade46-ea20-40f0-8433-afcdd014ae60.png"
    }
  }
];
